import React, { useEffect, useState } from "react";
import "../components/Dashboard/ProjectList.css";
import CreateProjectModal from "../components/ProjectModals/CreateProjectModal";

const ProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearch = async () => {
    const token = localStorage.getItem("auth_token");

    try {
      const res = await fetch(
        `https://loopsneller.com/api/projects/search?term=${encodeURIComponent(
          searchTerm
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error("Search failed");

      const data = await res.json();
      setProjects(data); // ✅ Update the UI to only show search results
    } catch (error) {
      console.error("Search error:", error);
      setError("Search failed");
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchResults([]);
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch("https://loopsneller.com/api/projects", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch projects");
        }

        const data = await response.json();
        setProjects(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (loading) {
    return (
      <div className="container mt-4">
        {/* <h2 className="mb-4">Projects</h2> */}
        <div className="row">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="col-md-4 mb-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="placeholder-glow">
                    <span className="placeholder col-6"></span>
                  </h5>
                  <p className="placeholder-glow">
                    <span className="placeholder col-12"></span>
                    <span className="placeholder col-8"></span>
                  </p>
                  <button className="btn btn-primary btn-sm disabled placeholder col-5"></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error)
    return <p className="text-danger text-center mt-3">Error: {error}</p>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center">
          <input
            type="text"
            className="form-control me-2"
            placeholder="Search projects..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "250px" }}
          />
          <button className="btn btn-primary me-2" onClick={handleSearch}>
            Search
          </button>
          <button className="btn btn-secondary" onClick={handleClearSearch}>
            Clear
          </button>
        </div>

        <CreateProjectModal
          onProjectCreated={(newProject) =>
            setProjects((prev) => [newProject, ...prev])
          }
        />
      </div>

      <div className="row">
        {projects.length === 0 ? (
          <div className="col-12 text-center text-muted mt-4">
            <p>No projects added yet.</p>
          </div>
        ) : (
          projects.map((project) => (
            <div key={project.id} className="col-md-4 mb-3">
              <div className="card project-card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{project.name}</h5>
                  <p className="card-text">
                    {project.description || "No description available."}
                  </p>
                  <a
                    href={`/projects/${project.id}`}
                    className="btn btn-primary btn-sm"
                  >
                    View Details
                  </a>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ProjectsPage;
